import { render, staticRenderFns } from "./TextareaView.vue?vue&type=template&id=a7c88722&"
import script from "./TextareaView.vue?vue&type=script&lang=js&"
export * from "./TextareaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports